import { InteractiveContainer } from "@jugl-web/ui-components";
import React from "react";
import { useTranslations } from "@jugl-web/utils";
import useEditorContext from "../useEditorContext";
import TransformTool from "../../tools/TransformTool";
import { ReactComponent as FlipIcon } from "../../assets/icons/flip.svg";
import { ReactComponent as RotateIcon } from "../../assets/icons/rotate.svg";

export const ToolbarActionTransform: React.FC = () => {
  const { instance } = useEditorContext();
  const { t } = useTranslations();

  const handleFlip = () => {
    if (instance?.activeTool instanceof TransformTool) {
      instance.activeTool.flip();
      instance.activeTool.createCropRect();
    }
  };

  const handleRotate = () => {
    if (instance?.activeTool instanceof TransformTool) {
      const result = instance.activeTool.rotate();
      if (!result) return;

      instance.setDimensions(result.imgWidth, result.imgHeight);
      instance.activeTool.createCropRect();
    }
  };

  return (
    <div className="flex items-center gap-10 text-[15px] leading-2 font-medium text-white">
      <InteractiveContainer
        className="flex h-8 items-center gap-2 px-4"
        onClick={handleFlip}
      >
        <FlipIcon />
        {t({
          id: "editor-image-component.flip",
          defaultMessage: "Flip",
        })}
      </InteractiveContainer>
      <InteractiveContainer
        className="flex h-8 items-center gap-2 px-4"
        onClick={handleRotate}
      >
        {t({
          id: "editor-image-component.rotate",
          defaultMessage: "Rotate",
        })}
        <RotateIcon />
      </InteractiveContainer>
    </div>
  );
};
